import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IUser } from '@appshared';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserApiService {
  protected resourceUrl = 'hrm-portal-api/api/users/';

  constructor(public http: HttpClient) {}

  getUserManagers(): Observable<any> {
    return this.http.get<IUser>(`${this.resourceUrl}managers`);
  }
}
